module.exports = __webpack_public_path__ + "static/media/respect.adfb43dd.png";